export const addImageModalActionTypes = {
	HANDLE_ADD_IMAGE_MODAL: 'HANDLE_ADD_IMAGE_MODAL',

	GET_IMAGES_REQUEST: 'GET_IMAGES_REQUEST',
	GET_IMAGES_SUCCESS: 'GET_IMAGES_SUCCESS',
	GET_IMAGES_ERROR: 'GET_IMAGES_ERROR',

	UPLOAD_IMAGE_REQUEST: 'UPLOAD_IMAGE_REQUEST',
	UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCESS',
	UPLOAD_IMAGE_ERROR: 'UPLOAD_IMAGE_ERROR',

	CLEAR_ADD_IMAGE_MODAL_STATE: 'CLEAR_ADD_IMAGE_MODAL_STATE',
} as const;

interface BlobWithName extends Blob {
	name: string;
}

declare global {
	interface Window {
		resolveLocalFileSystemURL: (
			path: string,
			successCallback: (fileEntry: any) => void,
			errorCallback?: (error: any) => void,
		) => void;
	}
}

export const convertImagePathToFile = (imagePath: string): Promise<BlobWithName> => {
	let processedPath = imagePath;
	if (processedPath.includes('/storage/')) {
		processedPath = `file://${processedPath}`;
	}
	return new Promise((resolve, reject) => {
		window.resolveLocalFileSystemURL(processedPath, (fileEntry: any) => {
			fileEntry.file((resFile: any) => {
				const reader = new FileReader();
				reader.onloadend = (evt) => {
					if (evt.target?.result) {
						const imgBlob = new Blob([evt.target.result], {
							type: 'image/jpeg',
						}) as BlobWithName;
						imgBlob.name = fileEntry.name;
						resolve(imgBlob);
					} else {
						reject(new Error('Failed to read file'));
					}
				};

				reader.onerror = (e) => {
					console.log(`Failed file read: ${e.toString()}`);
					reject(e);
				};

				reader.readAsArrayBuffer(resFile);
			});
		});
	});
};
